import { render, staticRenderFns } from "./Restaureringer.vue?vue&type=template&id=51d81c2e&"
import script from "./Restaureringer.vue?vue&type=script&lang=js&"
export * from "./Restaureringer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports